import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createAppRouter } from './router.tsx';
import { trackInputModality } from './state/inputModality.ts';
import { applyPreferences, usePreferences } from './state/preferences.ts';
import './styles/base.css';

applyPreferences(usePreferences.getState());
usePreferences.subscribe(applyPreferences);
trackInputModality();

const router = createAppRouter();
const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

createRoot(root).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
